import { ApiMethod } from '@wajeez-web/stores/base';
import { Server, contentClient } from '@wajeez-web/core/api-base';
import { AlertType, CommonActions } from '@wajeez-web/stores/common';
import { thunkErrorHandler } from '@wajeez-web/core/utils';

export const getAnswersAsDataTable: ApiMethod<
  Server.AnswerDatatableInput,
  Server.TableOfAnswerColumns,
  any
> = async (data, { dispatch, rejectWithValue }) => {
  try {
    const client = new Server.Server_Answers_Client(undefined, contentClient);

    const response = await client.admin_Answers_datatable_post_V1(data);

    if (response.success && response.data) {
      return response.data;
    }

    return rejectWithValue(response.errors);
  } catch (error: any) {
    const errors = JSON.parse(error.response).errors;

    dispatch(
      CommonActions.setAlert({
        type: AlertType.WARNING,
        messages: errors || [{ message: 'Something went wrong' }],
      })
    );

    return rejectWithValue(error);
  }
};

export const getAnswersByQuestionId: ApiMethod<
  number,
  Server.AnswerDashboardOutput[],
  any
> = async (data, { dispatch, rejectWithValue }) => {
  try {
    const client = new Server.Server_Answers_Client(undefined, contentClient);

    const response = await client.admin_Answers_lookups_byQuestionId_get_V1(
      undefined,
      data
    );

    if (response.success && response.data) {
      return response.data;
    }

    return rejectWithValue(response.errors);
  } catch (error: any) {
    const errors = JSON.parse(error.response).errors;

    dispatch(
      CommonActions.setAlert({
        for: 'modal',
        type: AlertType.WARNING,
        messages: errors || [{ message: 'Something went wrong' }],
      })
    );

    return rejectWithValue(error);
  }
};

export const createNewAnswer: ApiMethod<
  Server.AddAnswerInput,
  number,
  any
> = async (variables, { dispatch, rejectWithValue }) => {
  try {
    const client = new Server.Server_Answers_Client(undefined, contentClient);

    const response = await client.admin_Answers_add_post_V1(variables);

    if (response.success && response.data) {
      return response.data;
    }

    return rejectWithValue(response.errors);
  } catch (error: any) {
    const errors = JSON.parse(error.response).errors;

    dispatch(
      CommonActions.setAlert({
        for: 'modal',
        type: AlertType.WARNING,
        messages: errors || [{ message: 'Something went wrong' }],
      })
    );

    return rejectWithValue(error);
  }
};

export const editAnswer: ApiMethod<Server.EditAnswerInput, void, any> = async (
  variables,
  { dispatch, rejectWithValue }
) => {
  try {
    const client = new Server.Server_Answers_Client(undefined, contentClient);

    const response = await client.admin_Answers_edit_put_V1(variables);

    if (response.success) {
      return;
    }

    return rejectWithValue(response.errors);
  } catch (error: any) {
    const errors = JSON.parse(error.response).errors;

    dispatch(
      CommonActions.setAlert({
        for: 'modal',
        type: AlertType.WARNING,
        messages: errors || [{ message: 'Something went wrong' }],
      })
    );

    return rejectWithValue(error);
  }
};

export const deleteAnswer: ApiMethod<
  Server.DeleteAnswerInput,
  void,
  void
> = async (data, { dispatch, rejectWithValue }) => {
  return thunkErrorHandler(
    async () => {
      const client = new Server.Server_Answers_Client(undefined, contentClient);

      const response = await client.admin_Answers_delete_delete_V1(data);

      if (response.success) {
        return;
      }

      return rejectWithValue(response.errors);
    },
    dispatch,
    rejectWithValue
  );
};

export const setCorrectAnswer: ApiMethod<
  Server.SetAnswerCorrectInput,
  void,
  any
> = async (data, { dispatch, rejectWithValue }) => {
  try {
    const client = new Server.Server_Answers_Client(undefined, contentClient);

    const response = await client.admin_Answers_setCorrect_put_V1(data);

    if (response.success) {
      return;
    }

    return rejectWithValue(response.errors);
  } catch (error: any) {
    const errors = JSON.parse(error.response).errors;

    dispatch(
      CommonActions.setAlert({
        for: 'modal',
        type: AlertType.WARNING,
        messages: errors || [{ message: 'Something went wrong' }],
      })
    );

    return rejectWithValue(error);
  }
};
